import { updateReview } from '../../../../actions/siteadmin/WhyHostReview/deleteWhyHostReview';
import showToaster from '../../../../helpers/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;
  
  if (values.image == null) {
    showToaster({ messageId: 'uploadImage', toasterType: 'error' })
    return;
  }

  dispatch(updateReview(values));

}

export default submit;
